import { useEffect, useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import config from '../../config';
import VendorEditModal from '../../components/vendors/VendorEditModal';
import BankDetailsTab from '../../components/vendors/vendorDetails/tabs/BankDetailsTab';
import MaterialsTab from '../../components/vendors/vendorDetails/tabs/MaterialsTab';
import ContactsTab from '../../components/vendors/vendorDetails/tabs/ContactsTab';
import StatusEditModal from '../../components/vendors/VendorStatusEditModal';
import { PulseLoader } from "react-spinners";
import { Table, Pagination, Form, Row, Col, Button, Badge, Card, Alert } from 'react-bootstrap';
import { useHasPermission, PERMISSIONS } from '../../utils/permissions';

function VendorDetail() {
    const { id } = useParams();
    const [vendor, setVendor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    // const [showProductsModal, setShowProductsModal] = useState(false);
    const [activeTab, setActiveTab] = useState('contacts');
    const [showStatusModal, setShowStatusModal] = useState(false);

    // Purchase Orders state
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    // const [purchaseOrdersWIthTracebility, setPurchaseOrdersWIthTracebility] = useState([]);
    const [poLoading, setPoLoading] = useState(false);
    const [poPagination, setPoPagination] = useState({});
    // const [powtPagination, setPowtPagination] = useState({});
    const [poFilters, setPoFilters] = useState({
        page: 1,
        limit: 10,
        status: '',
        startDate: '',
        endDate: '',
        poNumber: '',
        quotationId: '',
        batchNumber: ''
    });

    // RFQ Responses state
    const [rfqResponses, setRfqResponses] = useState([]);
    const [rfqLoading, setRfqLoading] = useState(false);
    const [rfqPagination, setRfqPagination] = useState({});
    const [rfqFilters, setRfqFilters] = useState({
        page: 1,
        limit: 10,
        status: '',
        startDate: '',
        endDate: ''
    });

    // Production Traceability state
    // const [traceabilityData, setTraceabilityData] = useState([]);
    // const [traceabilityLoading, setTraceabilityLoading] = useState(false);
    // const [traceabilityPagination, setTraceabilityPagination] = useState({});
    const [
        traceabilityFilters,
        // setTraceabilityFilters
    ] = useState({
        page: 1,
        limit: 10,
        batchNumber: '',
        poNumber: '',
        status: '',
        startDate: '',
        endDate: ''
    });

    // Permission checks
    const canViewVendors = useHasPermission(PERMISSIONS.VIEW_VENDORS);
    const canEditVendors = useHasPermission(PERMISSIONS.EDIT_VENDORS);

    const fetchVendor = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${config.API_BASE_URL}/vendors/${id}`);
            setVendor(res.data);
        } catch (err) {
            console.error("Failed to fetch vendor", err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    const fetchPurchaseOrders = useCallback(async () => {
        setPoLoading(true);
        try {
            const params = new URLSearchParams();
            Object.entries(poFilters).forEach(([key, value]) => {
                if (value) params.append(key, value);
            });

            const res = await axios.get(`${config.API_BASE_URL}/vendors/${id}/purchase-orders-with-batches?${params}`);
            setPurchaseOrders(res.data.purchaseOrders);
            setPoPagination(res.data.pagination);
        } catch (err) {
            console.error("Failed to fetch purchase orders", err);
        } finally {
            setPoLoading(false);
        }
    }, [id, poFilters]);

    const fetchRfqResponses = useCallback(async () => {
        setRfqLoading(true);
        try {
            const params = new URLSearchParams();
            Object.entries(rfqFilters).forEach(([key, value]) => {
                if (value) params.append(key, value);
            });

            const res = await axios.get(`${config.API_BASE_URL}/vendors/${id}/rfq-responses-aggregate?${params}`);
            setRfqResponses(res.data.rfqResponses);
            setRfqPagination(res.data.pagination);
        } catch (err) {
            console.error("Failed to fetch RFQ responses", err);
        } finally {
            setRfqLoading(false);
        }
    }, [id, rfqFilters]);

    const fetchPurchaseOrdersWithBatches = useCallback(async () => {
        // setTraceabilityLoading(true);
        try {
            const params = new URLSearchParams();
            Object.entries(traceabilityFilters).forEach(([key, value]) => {
                if (value) params.append(key, value);
            });

            // const res = await axios.get(`${config.API_BASE_URL}/vendors/${id}/purchase-orders-with-batches?${params}`);
            // setPurchaseOrdersWIthTracebility(res.data.purchaseOrders);
            // setPowtPagination(res.data.pagination);
        } catch (err) {
            console.error("Failed to fetch purchase orders with batches", err);
        } finally {
            // setTraceabilityLoading(false);
        }
    }, [
        // id, 
        traceabilityFilters
    ]);

    useEffect(() => {
        fetchVendor();
    }, [fetchVendor]);

    useEffect(() => {
        if (vendor) {
            fetchPurchaseOrders();
            fetchRfqResponses();
        }
    }, [vendor, fetchPurchaseOrders, fetchRfqResponses]);

    useEffect(() => {
        if (vendor) {
            fetchPurchaseOrdersWithBatches();
        }
    }, [vendor, fetchPurchaseOrdersWithBatches]);

    if (loading) return <Layout><div className="text-center py-5"><PulseLoader color="#014b7cbb" size={9} /></div></Layout>;
    if (!vendor) return <Layout><p>Vendor not found.</p></Layout>;

    // If user can't view vendors, show permission denied
    if (!canViewVendors) {
        return (
            <Layout>
                <nav aria-label="breadcrumb" className="mb-3">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                        <li className="breadcrumb-item"><Link to="/vendors/">Vendors</Link></li>
                        <li className="breadcrumb-item active">Access Denied</li>
                    </ol>
                </nav>
                <Alert variant="danger" className="d-flex align-items-center">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    <div>
                        <strong>Access Denied</strong>
                        <p className="mb-0">You don't have permission to view vendor details. Contact your administrator for access.</p>
                    </div>
                </Alert>
            </Layout>
        );
    }

    return (
        <Layout>
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item"><Link to="/vendors/">Vendors</Link></li>
                    <li className="breadcrumb-item active">{vendor.business_name}</li>
                </ol>
            </nav>

            <div className="mb-3 d-flex justify-content-between align-items-center gap-3 flex-wrap">
                <h2 className="mb-0">Vendor Details</h2>
                {canEditVendors && (
                    <button className="btn btn-primary" onClick={() => setShowModal(true)}>
                        <i className="fas fa-edit me-2"></i>Edit Details
                    </button>
                )}
            </div>

            <div className="row g-5">
                {/* Left Column */}
                <div className="col-12 col-xxl-4 mt-0 px-0">
                    <div className="row g-3 h-100">
                        <div className="col-12 col-md-12 col-xl-7 col-xxl-12 px-0 pe-xl-2 ps-0">
                            <div className="card shadow-sm h-100">
                                <div className="card-body d-flex flex-column gap-3">
                                    {/* Header: Avatar & Basic Info */}
                                    <div className="d-flex flex-wrap align-items-center gap-3">
                                        <div className="avatar avatar-4xl flex-shrink-0">
                                            <img
                                                className="rounded-circle"
                                                src="/assets/img/team/default-avatar.png"
                                                alt="Vendor Avatar"
                                            />
                                        </div>
                                        <div className="flex-grow-1">
                                            <h3 className="mb-1">{vendor.business_name}</h3>
                                            {vendor.alias && <h5 className="text-body-secondary mb-1">{vendor.alias}</h5>}
                                            <p className="mb-1 text-muted fs-85">
                                                <i className="fa fa-star text-warning"></i>
                                                <i className="fa fa-star text-warning"></i>
                                                <i className="fa fa-star text-warning"></i>
                                                <i className="fa fa-star text-warning"></i>
                                                <i className="fa-regular fa-star text-warning-light"></i>
                                            </p>
                                            <span className="badge bg-light text-secondary fs-9">
                                                Vendor Code: {vendor.vendor_code}
                                            </span>
                                        </div>
                                    </div>

                                    <hr className="my-1" />

                                    {/* Contact & Details */}
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <p className="text-body-secondary mb-1 fs-85">
                                                <i className="fa fa-user me-2 text-body-quaternary"></i>
                                                {vendor.owner_name || 'N/A'}
                                            </p>
                                            <p className="text-body-secondary mb-1 fs-85">
                                                <i className="fa fa-calendar me-2 text-body-quaternary"></i>
                                                Since{' '}
                                                {new Date(vendor.created_at).toLocaleDateString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                })}
                                            </p>

                                            <p className="mb-1 fs-85">
                                                <Link to={`tel:${vendor.owner_contact_no}`} className="text-decoration-none text-dark">
                                                    <i className="fa fa-phone me-2 text-body-quaternary"></i>
                                                    {vendor.owner_contact_no}
                                                </Link>
                                            </p>


                                            <p className="mb-1 fs-85">
                                                <Link to={`mailto:${vendor.business_email}`} className="text-decoration-none text-dark">
                                                    <i className="fa fa-envelope me-2 text-body-quaternary"></i>
                                                    {vendor.business_email}
                                                </Link>
                                            </p>

                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">GSTIN: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.gst_registration === 'URD' || !vendor.gstin ? 'URD' : vendor.gstin}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-sm-6">
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">Industry Type: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.industry_type?.name}
                                                </div>
                                            </div>
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">Firm Type: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.firm_type}
                                                </div>
                                            </div>
                                            <div className="fs-85 mb-2">
                                                <strong className="d-block mb-0 text-body">Address</strong>
                                                <div className="text-body-secondary">
                                                    {vendor.address && <div>{vendor.address}</div>}
                                                    <div>
                                                        {vendor?.town}, {vendor.city}, {vendor.state} {vendor.pin_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="my-1" />
                                    <div className="row g-3">
                                        <div className="col-sm-6">

                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">PAN No.: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.pan_no}
                                                </div>
                                            </div>
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">TAN No.: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.tan_no}
                                                </div>
                                            </div>
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">Fssai No.: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.fssai_no}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-sm-6">
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">Credit Period Allowed: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.credit_period_allowed}
                                                </div>
                                            </div>
                                            <div className="fs-85 d-flex gap-2 flex-wrap mb-2">
                                                <strong className="text-body">Other Services: </strong>
                                                <div className="text-body-secondary">
                                                    {vendor.other_services}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="col-12 col-md-12 col-xl-5 col-xxl-12 px-0 ps-xl-2 pe-0">
                            <div className="card shadow-sm rounded-3 mb-4">
                                <div className="card-body d-flex flex-column  flex-md-row justify-content-between align-items-md-end gap-3">
                                    <div className="d-flex align-items-center gap-3">
                                        <div>
                                            <h6 className="text-secondary fw-semibold mb-1">Status</h6>
                                            <span className={`badge rounded-pill bg-${getStatusColor(vendor.status)} px-2 py-1 fs-9`}>
                                                {vendor.status?.charAt(0).toUpperCase() + vendor.status?.slice(1) || 'N/A'}
                                            </span>
                                        </div>
                                        <div>
                                            <h6 className="text-secondary fw-semibold mb-1">Verification</h6>
                                            <span className={`badge rounded-pill bg-${vendor.approved ? 'success' : 'danger'} px-2 py-1 fs-9`}>
                                                <i className={`fa ${vendor.approved ? 'fa-check-circle' : 'fa-times-circle'} me-1`}></i>
                                                {vendor.approved ? 'Approved' : 'Not Approved'}
                                            </span>
                                        </div>
                                    </div>

                                    {canEditVendors && (
                                        <div className="text-md-end mt-2 mt-md-0">
                                            <button
                                                className="btn btn-sm btn-outline-primary px-3"
                                                onClick={() => setShowStatusModal(true)}
                                            >
                                                <i className="fa fa-edit me-1"></i> Edit
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>


                            <div className="card overflow-hidden">
                                <ul className="nav nav-tabs p-2 bg-primary-subtle" id="nav-tab" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'contacts' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('contacts')}
                                        >Contacts Persons</button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'bank' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('bank')}
                                        >Bank Details</button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'materials' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('materials')}
                                        >Material Supplied</button>
                                    </li>
                                </ul>
                                <div className="card-body">


                                    <div className="tab-content">
                                        {activeTab === 'bank' && <BankDetailsTab bank_details={vendor.bank_details} onUpdated={fetchVendor} vendorId={vendor._id} canEditVendors={canEditVendors} />}
                                        {activeTab === 'materials' && <MaterialsTab materials={vendor.material_supplied} onUpdated={fetchVendor} vendorId={vendor._id} canEditVendors={canEditVendors} />}
                                        {activeTab === 'contacts' && <ContactsTab contacts={vendor.contact_persons} onUpdated={fetchVendor} vendorId={vendor._id} canEditVendors={canEditVendors} />}
                                    </div>


                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Right Column (Purchase Orders and RFQ Responses) */}
                <div className="col-12 col-xxl-8 px-0">
                    {/* Purchase Orders Section */}
                    <div className="mb-6">
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Purchase Orders</h3>
                                <small className="text-muted">Orders placed with this vendor</small>
                            </Card.Header>
                            <Card.Body>
                                {/* Filters */}
                                <Row className="mb-3 g-2">
                                    <Col md={2}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search PO Number"
                                            value={poFilters.poNumber}
                                            onChange={(e) => setPoFilters({ ...poFilters, poNumber: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search Quotation ID"
                                            value={poFilters.quotationId}
                                            onChange={(e) => setPoFilters({ ...poFilters, quotationId: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search Batch Number"
                                            value={poFilters.batchNumber}
                                            onChange={(e) => setPoFilters({ ...poFilters, batchNumber: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Select
                                            value={poFilters.status}
                                            onChange={(e) => setPoFilters({ ...poFilters, status: e.target.value, page: 1 })}
                                        >
                                            <option value="">All Status</option>
                                            <option value="Created">Created</option>
                                            <option value="Partial Received">Partial Received</option>
                                            <option value="Fully Received">Fully Received</option>
                                            <option value="Closed">Closed</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </Form.Select>
                                    </Col>
                                </Row>
                                <Row className="mb-3 g-2">
                                    <Col md={2}>
                                        <Form.Control
                                            type="date"
                                            placeholder="Start Date"
                                            value={poFilters.startDate}
                                            onChange={(e) => setPoFilters({ ...poFilters, startDate: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Control
                                            type="date"
                                            placeholder="End Date"
                                            value={poFilters.endDate}
                                            onChange={(e) => setPoFilters({ ...poFilters, endDate: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Button variant="outline-secondary" onClick={() => {
                                            setPoFilters({ page: 1, limit: 10, status: '', startDate: '', endDate: '', poNumber: '', quotationId: '', batchNumber: '' });
                                        }}>
                                            Clear Filters
                                        </Button>
                                    </Col>
                                </Row>

                                {poLoading ? (
                                    <div className="text-center py-4"><PulseLoader color="#014b7cbb" size={9} /></div>
                                ) : (
                                    <>
                                        <div className="table-responsive">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Order ID</th>
                                                        <th>Order Date</th>
                                                        <th>Items Ordered</th>
                                                        <th>RFQ Response</th>
                                                        <th>Broker</th>
                                                        <th>Production Batch</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {purchaseOrders.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="7" className="text-center text-muted">
                                                                No purchase orders found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        purchaseOrders.map((po) => (
                                                            <tr key={po._id}>
                                                                <td>
                                                                    <Link to={`/purchase-orders/${po._id}`} className="text-decoration-none">
                                                                        {po.orderId}
                                                                    </Link>
                                                                </td>
                                                                <td>{new Date(po.orderDate).toLocaleDateString()}</td>
                                                                <td>
                                                                    {po.po_items && po.po_items.length > 0 ? (
                                                                        po.po_items.map((item, idx) => (
                                                                            <div key={idx} className="mb-1">
                                                                                <small className="text-primary fw-semibold">
                                                                                    {item.product?.productName || 'Unknown Product'}
                                                                                </small>
                                                                                <br />
                                                                                <small className="text-muted">
                                                                                    Qty: {item.orderedQuantity} {item.unit || item.product?.unit || ''}
                                                                                </small>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <span className="text-muted">No items</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {po.quotation ? (
                                                                        <Link to={`/rfqs/${po.quotation.rfq}?response=${po.quotation._id}`} className="text-decoration-none">
                                                                            {po.quotation.quotationId}
                                                                        </Link>
                                                                    ) : 'N/A'}
                                                                </td>
                                                                <td>
                                                                    {po.broker ? (
                                                                        <Link to={`/brokers/${po.brokerId._id}`} className="text-decoration-none">
                                                                            {po.broker.business_name}
                                                                        </Link>
                                                                    ) : 'Direct'}
                                                                </td>
                                                                <td>
                                                                    {po.production_batches && po.production_batches.length > 0 ? (
                                                                        po.production_batches.map((batch, idx) => (
                                                                            <div key={batch._id || idx} className="d-flex align-items-center mb-1">
                                                                                <Link to={`/batch/${batch._id}`} className="text-decoration-none me-2">
                                                                                    {batch.batchNumber}
                                                                                </Link>
                                                                                <Badge size="sm" bg={getStatusColor(batch.status)}>
                                                                                    {batch.status}
                                                                                </Badge>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <span className="text-muted">No batches</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <Badge bg={getStatusColor(po.status)}>
                                                                        {po.status}
                                                                    </Badge>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>

                                        {/* Pagination */}
                                        {poPagination.totalPages > 1 && (
                                            <div className="d-flex justify-content-center mt-3">
                                                <Pagination>
                                                    <Pagination.First
                                                        disabled={poPagination.currentPage === 1}
                                                        onClick={() => setPoFilters({ ...poFilters, page: 1 })}
                                                    />
                                                    <Pagination.Prev
                                                        disabled={poPagination.currentPage === 1}
                                                        onClick={() => setPoFilters({ ...poFilters, page: poPagination.currentPage - 1 })}
                                                    />
                                                    {[...Array(poPagination.totalPages)].map((_, i) => (
                                                        <Pagination.Item
                                                            key={i + 1}
                                                            active={i + 1 === poPagination.currentPage}
                                                            onClick={() => setPoFilters({ ...poFilters, page: i + 1 })}
                                                        >
                                                            {i + 1}
                                                        </Pagination.Item>
                                                    ))}
                                                    <Pagination.Next
                                                        disabled={poPagination.currentPage === poPagination.totalPages}
                                                        onClick={() => setPoFilters({ ...poFilters, page: poPagination.currentPage + 1 })}
                                                    />
                                                    <Pagination.Last
                                                        disabled={poPagination.currentPage === poPagination.totalPages}
                                                        onClick={() => setPoFilters({ ...poFilters, page: poPagination.totalPages })}
                                                    />
                                                </Pagination>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </div>

                    {/* RFQ Responses Section */}
                    <div>
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">RFQ Responses</h3>
                                <small className="text-muted">All responses submitted by this vendor</small>
                            </Card.Header>
                            <Card.Body>
                                {/* Filters */}
                                <Row className="mb-3 g-2">
                                    <Col md={2}>
                                        <Form.Select
                                            value={rfqFilters.status}
                                            onChange={(e) => setRfqFilters({ ...rfqFilters, status: e.target.value, page: 1 })}
                                        >
                                            <option value="">All Status</option>
                                            <option value="pending">Pending</option>
                                            <option value="approved">Approved</option>
                                            <option value="rejected">Rejected</option>
                                            <option value="hold">Hold</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Control
                                            type="date"
                                            placeholder="Start Date"
                                            value={rfqFilters.startDate}
                                            onChange={(e) => setRfqFilters({ ...rfqFilters, startDate: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Control
                                            type="date"
                                            placeholder="End Date"
                                            value={rfqFilters.endDate}
                                            onChange={(e) => setRfqFilters({ ...rfqFilters, endDate: e.target.value, page: 1 })}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Button variant="outline-secondary" onClick={() => {
                                            setRfqFilters({ page: 1, limit: 10, status: '', startDate: '', endDate: '' });
                                        }}>
                                            Clear Filters
                                        </Button>
                                    </Col>
                                </Row>

                                {rfqLoading ? (
                                    <div className="text-center py-4"><PulseLoader color="#014b7cbb" size={9} /></div>
                                ) : (
                                    <>
                                        <div className="table-responsive">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Quotation ID</th>
                                                        <th>RFQ ID</th>
                                                        <th>Submitted Date</th>
                                                        <th>Status</th>
                                                        <th>Expected Delivery</th>
                                                        <th>Tax</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rfqResponses.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="6" className="text-center text-muted">
                                                                No RFQ responses found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        rfqResponses.map((response) => (
                                                            <tr key={response._id}>
                                                                <td>
                                                                    <Link to={`/rfqs/${response.rfq._id}?response=${response._id}`} className="text-decoration-none">
                                                                        {response.quotationId}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    {response.rfq ? (
                                                                        <Link to={`/rfqs/${response.rfq._id}`} className="text-decoration-none">
                                                                            {response.rfq.rfq_id}
                                                                        </Link>
                                                                    ) : 'N/A'}
                                                                </td>
                                                                <td>{new Date(response.submitted_at).toLocaleDateString()}</td>
                                                                <td>
                                                                    <Badge bg={getRfqStatusColor(response.status)}>
                                                                        {response.status}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    {response.expected_delivery_date ?
                                                                        new Date(response.expected_delivery_date).toLocaleDateString() :
                                                                        'N/A'
                                                                    }
                                                                </td>
                                                                <td>{response.tax || 0}%</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>

                                        {/* Pagination */}
                                        {rfqPagination.totalPages > 1 && (
                                            <div className="d-flex justify-content-center mt-3">
                                                <Pagination>
                                                    <Pagination.First
                                                        disabled={rfqPagination.currentPage === 1}
                                                        onClick={() => setRfqFilters({ ...rfqFilters, page: 1 })}
                                                    />
                                                    <Pagination.Prev
                                                        disabled={rfqPagination.currentPage === 1}
                                                        onClick={() => setRfqFilters({ ...rfqFilters, page: rfqPagination.currentPage - 1 })}
                                                    />
                                                    {[...Array(rfqPagination.totalPages)].map((_, i) => (
                                                        <Pagination.Item
                                                            key={i + 1}
                                                            active={i + 1 === rfqPagination.currentPage}
                                                            onClick={() => setRfqFilters({ ...rfqFilters, page: i + 1 })}
                                                        >
                                                            {i + 1}
                                                        </Pagination.Item>
                                                    ))}
                                                    <Pagination.Next
                                                        disabled={rfqPagination.currentPage === rfqPagination.totalPages}
                                                        onClick={() => setRfqFilters({ ...rfqFilters, page: rfqPagination.currentPage + 1 })}
                                                    />
                                                    <Pagination.Last
                                                        disabled={rfqPagination.currentPage === rfqPagination.totalPages}
                                                        onClick={() => setRfqFilters({ ...rfqFilters, page: rfqPagination.totalPages })}
                                                    />
                                                </Pagination>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </div>

                    
                </div>
            </div>



            <StatusEditModal
                show={showStatusModal}
                onHide={() => setShowStatusModal(false)}
                vendorId={vendor._id}
                initialStatus={vendor.status}
                initialApproved={vendor.approved}
                onUpdated={fetchVendor}
            />

            <VendorEditModal
                show={showModal}
                onHide={() => setShowModal(false)}
                vendor={vendor}
                onVendorUpdated={fetchVendor}
            />

        </Layout>
    );
}

// Optional: Color-coded status badges
function getStatusColor(status) {
    switch (status) {
        case 'in-progress':
            return 'success';
        case 'draft':
            return 'warning';
        case 'cancelled':
            return 'danger';
        case 'Deactive':
            return 'secondary';
        case 'completed':
            return 'primary';
        case 'Partial Received':
            return 'info';
        case 'Fully Received':
            return 'success';
        case 'paused':
            return 'secondary';
        case 'Cancelled':
            return 'danger';
        default:
            return 'secondary';
    }
}

function getRfqStatusColor(status) {
    switch (status) {
        case 'approved':
            return 'success';
        case 'pending':
            return 'warning';
        case 'rejected':
            return 'danger';
        case 'hold':
            return 'secondary';
        default:
            return 'light';
    }
}

export default VendorDetail;
